import {
  ADD_COMMISSION,
  ADD_COMMISSION_FAIL,
  ADD_COMMISSION_SUCCESS,
  GET_COMMISSIONS,
  GET_COMMISSIONS_FAIL,
  GET_COMMISSIONS_SUCCESS,
  REMOVE_COMMISSION,
  REMOVE_COMMISSION_FAIL,
  REMOVE_COMMISSION_SUCCESS,
  SET_PREVIOUS_FORM_DATA,
  SEARCH_VENDORS,
  CLEAR_FAILED_VENDORS,
  ADD_MULTIPLE_COMMISSIONS,
  ADD_MULTIPLE_COMMISSIONS_FINISHED,
  SET_SELECTED_VENDORS,
  GET_VENDORS,
  GET_ALL_VENDORS
} from './CommissionsActions'

// const dummyCommissions = JSON.parse(
//   '[{"id":"a7c436b4-9681-4315-bf25-edcf585d2dc7","merchantId":"ece78c82-e6b6-4b96-a16e-4a8346d420c4","vendorId":"11d0c72b-aa7f-4ec6-aeec-b8219ac645fc","type":"percentage","value":null,"amount":2,"references":"vendor","created_at":"2019-12-15T07:51:32.000Z","updated_at":"2019-12-15T09:51:14.000Z","maxAmount":132,"minAmount":12,"transactionType":"deposit","companyId":null,"fromDate":"2019-12-01","toDate":"2019-12-31","merchant":{"id":"ece78c82-e6b6-4b96-a16e-4a8346d420c4","name":"Comm Ission","phone":"00401231234","cui":"123","address":null,"registryNumber":"123","vatRegistryNumber":"123","series":"COMM","iban":"GB33BUKB20201555555555","email":"comm@xyz.com","contactPerson":"Mike","contactPersonPhone":"0040123123","contactPersonEmail":"mike@comm.com","userId":"bd49368e-9446-41d2-ab92-9f077a030aa3","expireDate":"2020-12-01T00:00:00.000Z","type":"merchant","created_at":"2019-12-12T13:56:36.000Z","updated_at":"2019-12-12T13:56:36.000Z","license":null,"deleted_at":null,"countyId":null,"country_renamed":null,"city_renamed":null,"street":"Zorilor","contractNumber":"1","minTransactionAmount":null,"maxTransactionAmount":null,"contractDate":"2019-12-01T00:00:00.000Z","cityId":"b1c35172-c64a-49ad-830a-d76cefc6013c","TVAPayer":1,"customerTransactionLimit":null,"customerDailyTransactionLimit":null,"customerLifetimeTransactionLimit":null,"apkVersionId":null,"countryId":"e65836f3-4e01-45a3-b0fa-d79ba82abf7d","hasVIPTerminal":0,"isWithdrawEnabled":1,"isDepositEnabled":1,"logoPath":null,"depositEndpoint":null,"depositAcceptedEndpoint":null,"withdrawEndpoint":null,"withdrawAcceptedEndpoint":null,"validateUserEndpoint":null,"hasBasicAuth":0,"basicAuthLogin":null,"requestContentType":"application/x-www-form-urlencoded","existingBalance":0,"limitTransactionsByExistingBalance":23,"sendTransactionReport":0,"transactionReportEmail":null,"creditLimit":0,"prepaidLimit":43},"vendor":{"id":"11d0c72b-aa7f-4ec6-aeec-b8219ac645fc","name":"CyBorg","phone":"0748152341","cui":"1356trws","address":null,"registryNumber":"13456da","vatRegistryNumber":"","series":"CYBO","iban":"GB33BUKB20201555555555","email":null,"contactPerson":null,"contactPersonPhone":null,"contactPersonEmail":null,"userId":"28003bc4-e9c3-4c77-91c9-bb5b58b18798","expireDate":"2020-11-01T00:00:00.000Z","type":"vendor","created_at":"2019-11-18T14:48:25.000Z","updated_at":"2019-11-28T15:17:21.000Z","license":"MIT","deleted_at":null,"countyId":null,"country_renamed":null,"city_renamed":null,"street":"Independentei, nr 32","contractNumber":"13","minTransactionAmount":null,"maxTransactionAmount":null,"contractDate":"2019-11-01T00:00:00.000Z","cityId":"d78eaa7f-397e-4969-94f1-051ff88522a8","TVAPayer":0,"customerTransactionLimit":10000,"customerDailyTransactionLimit":1000000,"customerLifetimeTransactionLimit":1000000,"apkVersionId":null,"countryId":"e65836f3-4e01-45a3-b0fa-d79ba82abf7d","hasVIPTerminal":0,"isWithdrawEnabled":1,"isDepositEnabled":1,"logoPath":null,"depositEndpoint":null,"depositAcceptedEndpoint":null,"withdrawEndpoint":null,"withdrawAcceptedEndpoint":null,"validateUserEndpoint":null,"hasBasicAuth":0,"basicAuthLogin":null,"requestContentType":"application/x-www-form-urlencoded","existingBalance":0,"limitTransactionsByExistingBalance":0,"sendTransactionReport":0,"transactionReportEmail":null,"creditLimit":0,"prepaidLimit":0}},{"id":"e5902585-1261-4537-8a4d-332bc2e81d75","merchantId":"ece78c82-e6b6-4b96-a16e-4a8346d420c4","vendorId":null,"type":"percentage","value":null,"amount":2,"references":"merchant","created_at":"2019-12-15T09:51:14.000Z","updated_at":"2019-12-15T09:51:14.000Z","maxAmount":111,"minAmount":23,"transactionType":"deposit","companyId":null,"fromDate":"2020-01-01","toDate":"2500-01-01","merchant":{"id":"ece78c82-e6b6-4b96-a16e-4a8346d420c4","name":"Comm Ission","phone":"00401231234","cui":"123","address":null,"registryNumber":"123","vatRegistryNumber":"123","series":"COMM","iban":"GB33BUKB20201555555555","email":"comm@xyz.com","contactPerson":"Mike","contactPersonPhone":"0040123123","contactPersonEmail":"mike@comm.com","userId":"bd49368e-9446-41d2-ab92-9f077a030aa3","expireDate":"2020-12-01T00:00:00.000Z","type":"merchant","created_at":"2019-12-12T13:56:36.000Z","updated_at":"2019-12-12T13:56:36.000Z","license":null,"deleted_at":null,"countyId":null,"country_renamed":null,"city_renamed":null,"street":"Zorilor","contractNumber":"1","minTransactionAmount":null,"maxTransactionAmount":null,"contractDate":"2019-12-01T00:00:00.000Z","cityId":"b1c35172-c64a-49ad-830a-d76cefc6013c","TVAPayer":1,"customerTransactionLimit":null,"customerDailyTransactionLimit":null,"customerLifetimeTransactionLimit":null,"apkVersionId":null,"countryId":"e65836f3-4e01-45a3-b0fa-d79ba82abf7d","hasVIPTerminal":0,"isWithdrawEnabled":1,"isDepositEnabled":1,"logoPath":null,"depositEndpoint":null,"depositAcceptedEndpoint":null,"withdrawEndpoint":null,"withdrawAcceptedEndpoint":null,"validateUserEndpoint":null,"hasBasicAuth":0,"basicAuthLogin":null,"requestContentType":"application/x-www-form-urlencoded","existingBalance":0,"limitTransactionsByExistingBalance":23,"sendTransactionReport":0,"transactionReportEmail":null,"creditLimit":0,"prepaidLimit":43}}]'
// )

const INITIAL_STATE = {
  failedVendors: [],
  commissions: [],
  loading: false,
  error: {},
  previousFormData: {},
  commissionVendors: [],
  commissionVendorsAux: [],
  successfullVendors: [],
  multipleCommissionsLoading: false,
  selectedVendors: [],
  vendors: [],
  allVendors: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_COMMISSIONS:
      return {
        ...state,
        loading: true,
        error: {},
        commissions: [],
        commissionVendors: [],
        commissionVendorsAux: []
      }
    case GET_COMMISSIONS_SUCCESS:
      let vendorsAux = []
      if (action.payload && action.payload.length > 0) {
        action.payload.forEach(item => {
          let index = vendorsAux && vendorsAux.findIndex(v => v && v.id === item.vendorId)
          if (index === -1) {
            vendorsAux.push(item.vendor)
          }
        })
      }
      return {
        ...state,
        commissions: action.payload,
        loading: false,
        commissionVendors: vendorsAux,
        commissionVendorsAux: vendorsAux,
        // failedVendors: []
      }
    case GET_COMMISSIONS_FAIL:
      return {
        ...state,
        loading: false,
        commissions: [],
        error: action.payload
      }
    case ADD_COMMISSION:
      return { ...state, loading: true, error: {}, failedVendors: [], successfullVendors: [] }
    case ADD_COMMISSION_SUCCESS:
      return {
        ...state,
        commissions: action.payload,
        loading: false,
        successfullVendors: [...state.successfullVendors, action.successfullVendor]
      }
    case ADD_COMMISSION_FAIL:
      return {
        ...state,
        loading: false,
        failedVendors: [...state.failedVendors, { msg: action.payload, failedVendor: action.failedVendor }],
        error: action.payload,
      }
    case REMOVE_COMMISSION:
      return { ...state, loading: true, error: {} }
    case REMOVE_COMMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        commissions: action.payload
      }
    case REMOVE_COMMISSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case SET_PREVIOUS_FORM_DATA:
      return {
        ...state,
        previousFormData: action.payload
      }

    case SEARCH_VENDORS:
      let vendors = []
      if (action.payload !== '') {
        if (state.commissionVendorsAux.length > 0) {
          state.commissionVendorsAux.forEach(item => {
            if (item && item.name && action.payload && item.name.toLowerCase().includes(action.payload.toLowerCase())) {
              vendors.push(item)
            }
          })
        }
      } else {
        vendors = state.commissionVendorsAux
      }
      return {
        ...state,
        commissionVendors: vendors
      }

    case CLEAR_FAILED_VENDORS:
      return {
        ...state,
        error: {},
        failedVendors: [],
        successfullVendors: []
      }

    case ADD_MULTIPLE_COMMISSIONS:
      return {
        ...state,
        multipleCommissionsLoading: true
      }

    case ADD_MULTIPLE_COMMISSIONS_FINISHED:
      return {
        ...state,
        multipleCommissionsLoading: false
      }

    case SET_SELECTED_VENDORS:
      return {
        ...state,
        selectedVendors: action.payload
      }

    case GET_ALL_VENDORS:
      return {
        ...state,
        vendors: action.payload.companies,
        allVendors: action.payload.companies
      }

    case GET_VENDORS:
      let companiesAux = action.payload.companies

      if (
        state.selectedVendors &&
        state.selectedVendors.length > 0 &&
        action.payload.companies &&
        action.payload.companies.length > 0
      ) {
        companiesAux.forEach(item => {
          if (state.selectedVendors.findIndex(x => x.id === item.id) !== -1) {
            item.active = true
          }
        })
      }

      return {
        ...state,
        vendors: companiesAux,
      }

    default:
      return state
  }
}
